import { SubmitType, AustralianState } from '@urbanx/agx-ui-components';
import GenerationStatus from '../GenerationStatus';

interface SalesContractGeneratingProps {
  generationStatus: GenerationStatus;
  submitType?: SubmitType;
  state?: AustralianState;
  generatingText?: string;
  completeText?: string;
}

const GeneratingHeaderTextPdf = {
  [AustralianState.QLD]: 'Generating Contract',
  [AustralianState.NSW]: 'Generating Sales Advice',
};
const GeneratingHeaderTextSend = {
  [AustralianState.QLD]: 'Sending for signing',
  [AustralianState.NSW]: 'Sending Sales Advice',
};

const SalesContractGenerating = ({
  generationStatus,
  submitType,
  state,
  generatingText,
  completeText,
}: SalesContractGeneratingProps) => {
  if (generationStatus === GenerationStatus.Generating) {
    return (
      generatingText ??
      (submitType === SubmitType.GeneratePdf
        ? GeneratingHeaderTextPdf[state as keyof typeof GeneratingHeaderTextPdf]
        : GeneratingHeaderTextSend[state as keyof typeof GeneratingHeaderTextPdf])
    );
  }

  if (generationStatus === GenerationStatus.Generated) {
    return completeText ?? (submitType === SubmitType.GeneratePdf ? 'Complete' : 'Sent');
  }
};

export default SalesContractGenerating;
